<template>
<div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="invoice-create-page">
    <!--  credit form component -->

    <RetainerInvoiceForm
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      page="update"
      v-on:FormUpdate="FormUpdate = 1"
      v-on:onSubmit="onSubmit($event)"
    ></RetainerInvoiceForm>
  </div>
</div>
</template>

<script>
import RetainerInvoiceForm from "@/components/Form/RetainerInvoice/RetainerInvoiceForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "PaymentCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    RetainerInvoiceForm,
    RecordNotFound
  },
  data() {
    return {
      duplicatecode: false,
      FormUpdate: 0,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("retainer/updateList", {
          id: this.$route.params.id,
          field: data,
        })
        .then((response) => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          if (this.status_code == 200) {

            //  show if invoice successfully created
            var saved_data = JSON.parse(data);

            if (saved_data.header_details.deposit_term_changed) {
              this.retainer_settings_details.internal_notes =
                saved_data.header_details.retainer_terms_cndtn;
            }
            if (saved_data.header_details.deposit_desc_changed) {
              this.retainer_settings_details.cus_inv_notes =
                saved_data.header_details.cus_inv_notes;
            }
            this.submitted = false;
            if (
              this.RoutePermission(
                false,
                "",
                "invoice",
                "paymentsreceived",
                "index"
              )
            ) {
              this.$router.push({
                name: "RetainerInvoiceView",
                params: { id: this.updated_id },
              });
            } else {
              this.$router.push({
                name: "RetainerInvoice",
              });
            }
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: response.status == "200" ? "success" : "danger",
              showCloseButton: true,
            });
          } else {
            //  showing eror message
            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    },
  },
 async beforeRouteEnter(routeTo, routeFrom, next) {
   await store.dispatch("retainer/fetchRetainerInvoiceDetails").then(() => {
      next();
    });
      await store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Customer Deposit",
        stg_name: "retainer_settings_details"
      })
      .then(() => {
        next();
      });

  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  updated: function () {},

  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.retainer.code,
      status_code: state => state.retainer.status_code, 
      status_message: state => state.retainer.status_message, 
      status_type: state => state.retainer.status_type,
      updated_id: (state) => state.retainer.updated_id,
    }),
    retainer_settings_details: {
      get() {
        return this.$store.state.permission.retainer_settings_details;
      },
      set(val) {
        this.$store.state.permission.inv_settings_details = val;
      },
    },
  },
};
</script> 

<style>
</style>
